import { ModuleConstants } from '@hrms/common/constant/modules';
import { ComponentsMap } from '@hrms/common/routes/components';
import { ScreenNames } from '@hrms/common/routes/screens';
import { ModuleRoutesComponentInterface } from '@hrms/common/routes/types';
import { generateImage } from '@hrms/common/utils/generateImage';

const getSeperationBlackListModuleRoutes: ModuleRoutesComponentInterface =
  () => [
    {
      id: ModuleConstants.BLACKLISTING_SEPERATION,
      route: '/termination',
      title: ScreenNames.TERMINATION,
      icon: generateImage({
        noScale: true,
        name: 'cancel',
        alt: 'cancel',
        className: 'w-4 h-4',
      }),
      component: null,
      children: [
        {
          id: ModuleConstants.BLACKLISTED_EMPLOYEE,
          route: '/termination/blacklisting',
          title: ScreenNames.BLACKLIST_EMPLOYEE,
          component: ComponentsMap.BLACKLIST_EMPLOYEE,
        },
        {
          id: ModuleConstants.SEPARATION,
          route: '/termination/separation',
          title: ScreenNames.SEPARATION,
          component: ComponentsMap.SEPARATION,
        },
      ],
    },
  ];

export default getSeperationBlackListModuleRoutes;
